import { useShallow } from "zustand/react/shallow";

import { useWaterlyAppStore } from "../stores";

export const useEnvironment = () => useWaterlyAppStore(useShallow((s) => s.env));
